<template>
  <el-collapse id="benefitTab">
    <el-collapse-item v-for="(item, index) in collapses" :key="item.key" :name="item.key">
      <template #title> {{ index + 1 }}.&nbsp;{{ $t(`promotion.vps.faq.${item.question}`) }} </template>
      <div class="answer_container">
        <div v-for="(child1, child1_i) in item.answer" class="answer_class text-grayG4" :key="child1_i">
          <!-- answer level 1 -->
          <p class="mb-2 answer_class">
            {{ $t(`promotion.vps.faq.${child1.key}`) }}
          </p>
          <!-- answer level 2 (disc bullet point)-->
          <ul v-if="child1.desc">
            <li v-for="(child2, child2_i) in child1.desc" :key="child2_i">
              <span v-html="$t(`promotion.vps.faq.${child2.key}`)"></span>
              <!-- answer level 3 (circle bullet point)-->
              <ul v-if="child2.desc">
                <li v-for="(child3, child3_i) in child2.desc" class="pl-3" :key="child3_i">
                  {{ $t(`promotion.vps.faq.${child3}`) }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'VpsFaq',
  data() {
    return {
      collapses: [
        {
          key: '1',
          question: 'question1',
          answer: [{ key: 'answer1' }]
        },
        {
          key: '2',
          question: 'question2',
          answer: [{ key: 'answer2' }, { key: 'answer2a', desc: [{ key: 'answer2a1' }] }]
        },
        {
          key: '3',
          question: 'question3',
          answer: [{ key: 'answer3' }]
        },
        {
          key: '4',
          question: 'question4',
          answer: [
            { key: 'answer4' },
            {
              key: 'answer4a',
              desc: [
                { key: 'answer4a1' },
                {
                  key: 'answer4a2',
                  desc: ['answer4a2a', 'answer4a2b', 'answer4a2c']
                }
              ]
            }
          ]
        },
        {
          key: '5',
          question: 'question5',
          answer: [{ key: 'answer5' }]
        },
        {
          key: '6',
          question: 'question6',
          answer: [{ key: 'answer6', desc: [{ key: 'answer6a' }, { key: 'answer6b' }, { key: 'answer6c' }] }]
        },
        {
          key: '7',
          question: 'question7',
          answer: [{ key: 'answer7', desc: [{ key: 'answer7a' }, { key: 'answer7b' }, { key: 'answer7c' }] }]
        },
        {
          key: '8',
          question: 'question8',
          answer: [{ key: 'answer8' }]
        },
        {
          key: '9',
          question: 'question9',
          answer: [
            {
              key: 'answer9',
              desc: [{ key: 'answer9a' }, { key: 'answer9b' }, { key: 'answer9c' }]
            },
            { key: 'answer9d' }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#benefitTab /deep/ {
  border: none;
  padding: 20px 12px;
  .el-collapse-item {
    .el-collapse-item__header {
      font-size: 16px;
      font-weight: 600;
      padding: 12px 24px;
      line-height: 24px;
      height: auto;
      gap: 12px;
    }

    .el-collapse-item__content {
      font-size: 14px;
      border: none;
      padding: 12px 24px 14px;
    }

    .el-collapse-item__arrow {
      color: $primary-blue;
      font-weight: 600;
      &.is-active {
        transform: rotate(-90deg);
      }
    }
  }

  .bold_text {
    color: #3b3b3b;
    font-weight: bolder;
  }
}

.answer_container {
  .answer_class {
    line-height: 1.6;

    &:not(:first-child) {
      margin-top: 20px;
    }

    &:last-child {
      margin-bottom: 10px;
    }
  }
}

ul {
  padding-left: 20px;
}

li {
  list-style-type: disc;
  li {
    list-style-type: circle;
  }
}

@media screen and (max-width: 550px) {
  #benefitTab /deep/ {
    border: none;
    .el-collapse-item {
      .el-collapse-item__header {
        padding: 12px;
      }
    }
  }
}
</style>
